import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { fetchRevenueStat } from '../../api/subscription';

const RevenueAnalytics = () => {
  const [revenueData, setRevenueData] = useState({});
  // const { filter } = useSelector((state) => state);
  const filter = useSelector((state) => state.filter);
  const filterWithoutUTM = useMemo(() => {
    const { utm_options, searchTerm, ...rest } = filter;
    return rest;
  }, [JSON.stringify(filter)]);

  const fetchData = async () => {
    try {
      await fetchRevenueStat(filter, setRevenueData);
    } catch (error) {
      console.error('Error while loading real-time data', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [JSON.stringify(filterWithoutUTM)]);

  return (
    <div>
      <div className="d-flex gap-4 border p-20 rounded-4">
        <div className="w-400-px">
          {/* <div className="font-14 fw-normal text-neutral-900 d-flex align-items-center gap-3">
            Total Revenue{" "}
            <span className="text-neutral-500">
              $ {revenueData?.totalRevenue}
            </span>
          </div> */}
          <div className="font-24 fw-medium text-neutral-900">
            Revenue{' '}
            <span className="text-neutral-900 font-32 d-block">
              $ {revenueData?.totalRevenue}
            </span>
          </div>
          <div className="font-14 fw-normal text-neutral-900">
            Displays revenue generated
          </div>
        </div>
        <div className="d-flex align-items-center flex-column gap-3 w-100">
          <div className="w-100 d-flex flex-column gap-2">
            <div className="d-flex align-items-center justify-content-between gap-2 w-100">
              <div className="">
                Gold{' '}
                <span className="text-secondary-light font-xs fw-semibold line-height-1">
                  {revenueData?.totalGoldRevenuePercent}%
                </span>
              </div>
              <div className="">$ {revenueData?.totalGoldRevenue}</div>
            </div>
            <div className="w-100 ms-auto">
              <div
                className="progress progress-md rounded-pill"
                role="progressbar"
                aria-label="Success example"
                aria-valuenow={revenueData?.totalGoldRevenuePercent}
                aria-valuemin={0}
                aria-valuemax={100}
              >
                <div
                  className="progress-bar bg-primary-600 rounded-pill"
                  style={{
                    width: `${revenueData?.totalGoldRevenuePercent}%`,
                  }}
                />
              </div>
            </div>
          </div>
          <div className="w-100 d-flex flex-column gap-2">
            <div className="d-flex align-items-center justify-content-between gap-2 w-100">
              <div className="">
                Luxury{' '}
                <span className="text-secondary-light font-xs fw-semibold line-height-1">
                  {revenueData?.totalLuxuryRevenuePercent}%
                </span>
              </div>
              <div className="">$ {revenueData?.totalLuxuryRevenue}</div>
            </div>
            <div className="w-100 ms-auto">
              <div
                className="progress progress-md rounded-pill"
                role="progressbar"
                aria-label="Success example"
                aria-valuenow={revenueData?.totalLuxuryRevenuePercent}
                aria-valuemin={0}
                aria-valuemax={100}
              >
                <div
                  className="progress-bar bg-primary-600 rounded-pill"
                  style={{
                    width: `${revenueData?.totalLuxuryRevenuePercent}%`,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RevenueAnalytics;
